<template>
  <div class="tit-box">
    <div class="tit-left"></div>
    <div class="tit-center">
      <div class="text">{{ title }}</div>
    </div>
    <div class="tit-right"></div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  title: {
    type: String,
    default: "",
  },
});
</script>

<style scoped lang="scss">
.tit-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  .tit-left {
    width: 58px;
    height: 4px;
    background: url("@/assets/report/tit-left.png") no-repeat left center;
    background-size: contain;
  }

  .tit-center {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 96px;
    height: 26px;
    font-weight: bold;
    font-size: 19px;
    color: #a07dff;
    background: url("@/assets/report/tit-bottom.png") no-repeat center center;
    background-size: 100% 100%;
    .text {
      white-space: nowrap;
      margin-bottom: 5px;
    }
  }

  .tit-right {
    width: 58px;
    height: 4px;
    background: url("@/assets/report/tit-right.png") no-repeat right center;
    background-size: contain;
  }
}
</style>
